<template>
  <my-dialog
    @hideMask="$emit('handleInspectionTourSettingDialogClose')"
    :dialogFlag="inspectionTourSettingDialogFlag"
    width="660px"
    p_lr="0"
    borderRadius="8px"
    :hideMaskFlag="false"
    :clickMaskForHide="true"
  >
    <div class="inspection_tour_setting_container">
      <div class="inspection_tour_setting_container_header">
        <h3 class="header_title">设置</h3>
        <div class="close_btn" @click="$emit('handleInspectionTourSettingDialogClose')">
          <img
            src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/322b44f4a1e34d8cb527d1e033ec659b.png"
            alt="关闭"
          />
        </div>
      </div>
      <div class="inspection_tour_setting_container_body">
        <ul class="inspection_tour_setting_menu">
          <li
            :class="[item.key === settingMenuActive ? 'active' : '']"
            v-for="item in settingMenuList"
            :key="item.key"
            @click="handleSettingMenu(item)"
          >
            <img :src="item.key === settingMenuActive ? item.selectedIconPath : item.iconPath" :alt="item.text" />
            <p>{{ item.text }}</p>
          </li>
        </ul>
        <div class="inspection_tour_setting_content">
          <div class="video_setting" v-show="settingMenuActive === 'video'">
            <div class="video_setting_select">
              <h3>教室摄像头</h3>
              <a-select
                v-model:value="videoDeviceSelected"
                style="width: 200px"
                @change="handleVideoDeviceSelectedChange"
                placeholder="请选择摄像头"
              >
                <a-select-option :value="item.deviceId" v-for="item in videoDeviceList" :key="item.deviceId">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </div>
            <div class="video_setting_play">
              <div id="J_prismPlayer" v-if="rtcType === 'artc'"></div>
              <video src="" autoplay muted :id="domVideoId" v-else></video>
              <div
                :class="['shooting_angle_btn', shootingAngleBtnDisabled ? 'disabled' : '']"
                @click="handleShootingAngle"
                v-if="!shootingAngleFlag"
              >
                调整拍摄角度
              </div>
              <div class="video_setting_play_control_mask" v-else>
                <div class="device_title">
                  <span>当前设备：</span>
                  <span>{{ dialogDetailInfo.classroomName || '- -' }}</span>
                </div>
                <div class="direction_module">
                  <div class="direction_module_circle">
                    <div
                      class="direction_module_circle_button_of_one"
                      :style="item.styleObj"
                      v-for="item in directionModuleButtonList"
                      :key="item.title"
                      @mousedown="operationOfButton(item, 'direction', 'down')"
                      @mouseup="operationOfButton(item, 'direction', 'up')"
                    >
                      <img :src="item.icon" :alt="item.title" />
                    </div>
                  </div>
                </div>
                <div class="zoom_module">
                  <div class="zoom_module_title">镜头</div>
                  <div
                    class="zoom_module_button_of_one"
                    :style="item.styleObj"
                    v-for="item in zoomModuleButtonList"
                    :key="item.title"
                    @mousedown="operationOfButton(item, 'zoom', 'down')"
                    @mouseup="operationOfButton(item, 'zoom', 'up')"
                  >
                    <img :src="item.icon" :alt="item.title" />
                  </div>
                </div>
                <div class="footer_module">
                  <div class="confirm_btn" @click="shootingAngleFlag = false">完成</div>
                </div>
              </div>
            </div>
            <div class="video_setting_footer">
              <a-checkbox v-model:checked="mirrorMode" @change="(e) => handleMirrorModeChange(e)">镜像模式</a-checkbox>
            </div>
          </div>
          <div class="audio_setting" v-show="settingMenuActive === 'audio'">
            <div class="audio_setting_select">
              <h3>教室麦克风</h3>
              <a-select
                v-model:value="audioDeviceSelected"
                style="width: 240px"
                @change="handleAudioDeviceSelectedChange"
                placeholder="请选择麦克风"
              >
                <a-select-option :value="item.deviceId" v-for="item in audioDeviceList" :key="item.deviceId">
                  {{ item.label }}
                </a-select-option>
              </a-select>
              <i class="test_mic_btn" @click="handleTestMic">{{ testMicFlag ? '检测中' : '检测麦克风' }}</i>
            </div>
            <div class="audio_data_show">
              <!-- <audio src="" controls :id="domAudioId"></audio> -->
              <div class="audio_data_show_item">
                <p class="audio_data_show_item_title">输出等级</p>
                <a-progress :percent="outpuLLevel" :showInfo="false" style="width: 278px" />
              </div>
              <div class="audio_data_show_item">
                <p class="audio_data_show_item_title">
                  <span>音量</span>
                  <img
                    src="https://image.zhihuishu.com/zhs/b2cm/base1/202307/9eca182609554a1ca7642086defbc839.png"
                    alt="音量"
                  />
                </p>
                <a-slider v-model:value="volumeCount" style="width: 278px" @change="handleVolumeCountChange" />
              </div>
            </div>
            <div class="advanced_setting">
              <div class="advanced_setting_title">
                <h3>高级设置</h3>
                <h4>背景音降噪</h4>
              </div>
              <div class="advanced_setting_body">
                <a-select
                  v-model:value="noiseReductionSelected"
                  style="width: 240px"
                  @change="handleNoiseReductionSelectedChange"
                  placeholder="请选择背景音降噪"
                >
                  <a-select-option :value="item.key" v-for="item in noiseReductionList" :key="item.key">
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div class="general_setting" v-show="settingMenuActive === 'general'">
            <div class="general_setting_type_group">
              <div class="general_setting_type_item">
                <h3>启动时</h3>
                <div class="general_setting_btn_group">
                  <template v-for="item in generalSettingBtnGroup">
                    <div class="general_setting_btn_item" :key="item.title" v-if="item.type === 'atStartup'">
                      <a-checkbox
                        v-model:checked="item.checked"
                        :disabled="item.disabled"
                        @change="(e) => handleGeneralSettingChange(e, item)"
                      >
                        {{ item.title }}
                      </a-checkbox>
                    </div>
                  </template>
                </div>
              </div>
              <div class="general_setting_type_item">
                <h3>高级设置</h3>
                <div class="general_setting_btn_group">
                  <template v-for="item in generalSettingBtnGroup">
                    <div class="general_setting_btn_item" :key="item.title" v-if="item.type === 'advanced'">
                      <a-checkbox
                        v-model:checked="item.checked"
                        :disabled="item.disabled"
                        @change="(e) => handleGeneralSettingChange(e, item)"
                      >
                        {{ item.title }}
                      </a-checkbox>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="version_container">
              <img
                src="https://image.zhihuishu.com/zhs/b2cm/base1/202307/939b8a85907d497790979c5d6c074c64.png"
                alt="logo"
                class="logo"
              />
              <p class="title">版本号：{{ clientVersion }}</p>
              <p class="sub_title" v-if="isLatest">当前已经是最新版本</p>
              <p class="sub_title" v-else>检测到最新版本{{ latestClientVersion }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </my-dialog>
</template>

<script>
export default {
  name: 'inspectionTourSetting',
  components: {
    'my-dialog': () => import('@/components/my_dialog')
  },
  data() {
    return {
      settingMenuList: [
        {
          text: '视频',
          key: 'video',
          iconPath: 'https://image.zhihuishu.com/zhs/b2cm/base1/202307/677cd1377bec45c29a78ff06e5d17f4e.png',
          selectedIconPath: 'https://image.zhihuishu.com/zhs/b2cm/base1/202307/bb95f59ca05f4e178af2682e736915ca.png'
        },
        {
          text: '音频',
          key: 'audio',
          iconPath: 'https://image.zhihuishu.com/zhs/b2cm/base1/202307/9eca182609554a1ca7642086defbc839.png',
          selectedIconPath: 'https://image.zhihuishu.com/zhs/b2cm/base1/202307/61ec80a49a1847d59d83ad5cc381a3e1.png'
        },
        {
          text: '常规设置',
          key: 'general',
          iconPath: 'https://image.zhihuishu.com/zhs/b2cm/base1/202307/8c269e82eb8242b19c661ed268a11a89.png',
          selectedIconPath: 'https://image.zhihuishu.com/zhs/b2cm/base1/202307/e774f68ffa4b49fd8d282c261ed7a5e0.png'
        }
      ],
      settingMenuActive: 'video',
      videoDeviceList: [],
      videoDeviceSelected: undefined,
      mirrorMode: false,
      shootingAngleFlag: false,
      directionModuleButtonList: [
        {
          title: '上',
          icon: require('../../assets/img/vidiconControl/top.png'),
          iconGray: require('../../assets/img/vidiconControl/top.png'),
          iconHighLight: require('../../assets/img/vidiconControl/top_highlight.png'),
          styleObj: {
            top: '0px',
            left: '50%',
            transform: 'translateX(-50%)'
          },
          action: 1
        },
        {
          title: '右',
          icon: require('../../assets/img/vidiconControl/right.png'),
          iconGray: require('../../assets/img/vidiconControl/right.png'),
          iconHighLight: require('../../assets/img/vidiconControl/right_highlight.png'),
          styleObj: {
            top: '50%',
            right: '0px',
            transform: 'translateY(-50%)'
          },
          action: 4
        },
        {
          title: '下',
          icon: require('../../assets/img/vidiconControl/bottom.png'),
          iconGray: require('../../assets/img/vidiconControl/bottom.png'),
          iconHighLight: require('../../assets/img/vidiconControl/bottom_highlight.png'),
          styleObj: {
            bottom: '0px',
            left: '50%',
            transform: 'translateX(-50%)'
          },
          action: 2
        },
        {
          title: '左',
          icon: require('../../assets/img/vidiconControl/left.png'),
          iconGray: require('../../assets/img/vidiconControl/left.png'),
          iconHighLight: require('../../assets/img/vidiconControl/left_highlight.png'),
          styleObj: {
            top: '50%',
            left: '0px',
            transform: 'translateY(-50%)'
          },
          action: 3
        }
      ],
      zoomModuleButtonList: [
        {
          title: '加',
          icon: require('../../assets/img/vidiconControl/icon_jia_black.png'),
          iconGray: require('../../assets/img/vidiconControl/icon_jia_white.png'),
          iconHighLight: require('../../assets/img/vidiconControl/icon_jia_black.png'),
          styleObj: {
            marginRight: '54px'
          },
          action: 11
        },
        {
          title: '减',
          icon: require('../../assets/img/vidiconControl/icon_jian_black.png'),
          iconGray: require('../../assets/img/vidiconControl/icon_jian_white.png'),
          iconHighLight: require('../../assets/img/vidiconControl/icon_jian_black.png'),
          action: 12
        }
      ],
      audioDeviceList: [],
      audioDeviceSelected: undefined,
      outpuLLevel: 0,
      volumeCount: 40,
      noiseReductionList: [
        {
          title: '关闭噪声抑制',
          key: 0
        },
        {
          title: '低级',
          key: 1
        },
        {
          title: '中级',
          key: 2
        },
        {
          title: '高级',
          key: 3
        },
        {
          title: '非常高',
          key: 4
        }
      ],
      noiseReductionSelected: undefined,
      generalSettingBtnGroup: [
        {
          title: '自动开启“教室直播”',
          key: 'openClassroomLive',
          disabled: true,
          checked: true,
          type: 'atStartup'
        },
        {
          title: '自动开启“屏幕共享”',
          key: 'openShareScreen',
          disabled: true,
          checked: false,
          type: 'atStartup'
        },
        {
          title: '开启“调试模式”',
          key: 'enabledDebugMode',
          disabled: true,
          checked: false,
          type: 'advanced'
        },
        {
          title: '禁用“共享声音”',
          key: 'disabledScreenAudio',
          disabled: true,
          checked: false,
          type: 'advanced'
        }
        // {
        //   title: '开启“RTMP直播”',
        //   key: 'pushRtmp',
        //   disabled: true,
        //   checked: false,
        //   type: 'advanced'
        // }
      ],
      clientVersion: '- -',
      isLatest: true,
      latestClientVersion: '- -',
      playerForAliplayer: null,
      testMicFlag: false,
      testAudioContext: null,
      lGainNodeForOperationForStartTheMicrophone: null,
      rGainNodeForOperationForStartTheMicrophone: null,
      shootingAngleBtnDisabled: false
    }
  },
  props: {
    inspectionTourSettingDialogFlag: {
      type: Boolean,
      default: false
    },
    dialogDetailInfo: {
      type: Object,
      default: {}
    },
    streamMap: {
      type: Map,
      default: new Map()
    },
    clientForZRTC: {
      type: Object | null,
      default: null
    },
    clientSettingsInfo: {
      type: Object,
      default: {}
    },
    mediaDeviceInfo: {
      type: Object,
      default: {}
    },
    classroomInspectionDetailInfo: {
      type: Object,
      default: {}
    },
    rtcType: {
      type: String,
      default: 'artc'
    }
  },
  computed: {
    domVideoId: function () {
      if (!Object.keys(this.dialogDetailInfo).length) return ''
      const { uid, role } = this.dialogDetailInfo
      const id = `dialog_video_uid${uid}_role${role}`
      return id
    }
    // domAudioId: function () {
    //   if (!Object.keys(this.dialogDetailInfo).length) return ''
    //   const { uid, role } = this.dialogDetailInfo
    //   const id = `dialog_audio_uid${uid}_role${role}`
    //   return id
    // }
  },
  watch: {
    dialogDetailInfo: {
      handler: function (newVal) {
        if (!Object.keys(newVal).length) return
        this.operationDOM()
      }
    },
    inspectionTourSettingDialogFlag: {
      handler: function (newVal) {
        if (newVal) {
          this.operationDOM()
        } else {
          this.testMicFlag = false
          this.disposeAudioSetting()
        }
      }
    },
    rtcType: {
      handler: function (newVal) {
        if (newVal) {
          this.operationDOM()
        }
      }
    },
    clientSettingsInfo: {
      handler: function (newVal) {
        if (!Object.keys(newVal).length) return
        this.mirrorMode = newVal.enabledMirrorMode ? true : false
        this.noiseReductionSelected = [0, 1, 2, 3, 4].includes(newVal.ans) ? newVal.ans : undefined
        this.generalSettingBtnGroup = this.generalSettingBtnGroup.map((item) => {
          item.checked = newVal[item.key] ? true : false
          if (['openShareScreen', 'enabledDebugMode', 'disabledScreenAudio', 'pushRtmp'].includes(item.key)) {
            item.disabled = false
          }
          return item
        })
        this.clientVersion = newVal['clientVersion']
        this.isLatest = newVal['isLatest']
        this.latestClientVersion = newVal['latestClientVersion']
      }
    },
    mediaDeviceInfo: {
      handler: function (newVal) {
        if (!Object.keys(newVal).length) return
        const { videoDeviceList, videoDeviceSelected, audioDeviceList, audioDeviceSelected } = newVal
        this.videoDeviceList = videoDeviceList
        this.videoDeviceSelected = videoDeviceSelected
        this.audioDeviceList = audioDeviceList
        this.audioDeviceSelected = audioDeviceSelected
      }
    },
    videoDeviceSelected: {
      handler: function (newVal) {
        const videoDeviceSelectedObj = this.videoDeviceList.find((item) => item.deviceId === newVal) || {}
        if (videoDeviceSelectedObj.isHighSafe) {
          this.shootingAngleBtnDisabled = false
        } else {
          this.shootingAngleBtnDisabled = true
          this.shootingAngleFlag && (this.shootingAngleFlag = false)
        }
      }
    }
  },
  methods: {
    handleSettingMenu({ key }) {
      this.settingMenuActive = key
    },
    handleVideoDeviceSelectedChange(value) {
      this.$emit('switchVideo', value)
    },
    handleShootingAngle() {
      if (this.shootingAngleBtnDisabled) return
      this.shootingAngleFlag = true
    },
    operationOfButton(item, module, type) {
      const { title, action } = item
      switch (module) {
        case 'direction':
          switch (type) {
            case 'down':
              this.directionModuleButtonList = this.directionModuleButtonList.map((v) => {
                if (v.title === title) {
                  v.icon = v.iconHighLight
                }
                return v
              })
              this.liveDeviceControl(action)
              break
            case 'up':
              this.directionModuleButtonList = this.directionModuleButtonList.map((v) => {
                if (v.title === title) {
                  v.icon = v.iconGray
                }
                return v
              })
              break
          }
          break
        case 'zoom':
          switch (type) {
            case 'down':
              this.zoomModuleButtonList = this.zoomModuleButtonList.map((v) => {
                if (v.title === title) {
                  v.icon = v.iconGray
                }
                return v
              })
              this.liveDeviceControl(action)
              break
            case 'up':
              this.zoomModuleButtonList = this.zoomModuleButtonList.map((v) => {
                if (v.title === title) {
                  v.icon = v.iconHighLight
                }
                return v
              })
              break
          }
          break
      }
    },
    async liveDeviceControl(action) {
      if (this.clientForZRTC) {
        try {
          await this.clientForZRTC.ptz(this.dialogDetailInfo.cameraId, action, 5, 500)
        } catch (err) {
          console.log(err)
        }
      }
    },
    handleAudioDeviceSelectedChange(value) {
      this.$emit('switchAudio', value)
    },
    async handleNoiseReductionSelectedChange(value) {
      try {
        const { classroomCode } = this.$route.query
        const params = {
          ans: value,
          classroomCode
        }
        const result = await this.$http.settingSetClassroomNoiseAns(params)
        if (result.code !== 200) return this.$message.error('抱歉，设置失败！')
        this.$message.success('设置成功！')
      } catch (err) {
        console.log(err)
      }
    },
    operationDOM() {
      if (!this.inspectionTourSettingDialogFlag) return
      this.$nextTick(() => {
        const { cdnRtsPullUrl } = this.classroomInspectionDetailInfo
        if (this.rtcType === 'artc') {
          this.initAliplayerVideo(cdnRtsPullUrl)
        } else {
          if (!this.domVideoId) return
          const domVideo = document.querySelector(`#${this.domVideoId}`)
          const videoStreamId = (this.dialogDetailInfo.currentVideoDevice[0] || { streamId: '' }).streamId
          if (domVideo) {
            if (domVideo.srcObject !== this.streamMap.get(videoStreamId)) {
              domVideo.srcObject = this.streamMap.get(videoStreamId)
            }
          }
        }
      })
    },
    async clientSettingEdit(params) {
      const result = await this.$http.clientSettingEdit(params)
      if (result.code !== 200) return this.$message.error('抱歉，设置失败！')
      this.$emit('getClientSettings')
    },
    handleMirrorModeChange(e) {
      const params = JSON.parse(JSON.stringify(this.clientSettingsInfo))
      Object.assign(params, {
        enabledMirrorMode: e.target.checked ? 1 : 0
      })
      this.clientSettingEdit(params)
    },
    async handleGeneralSettingChange(e, item) {
      if (item.key === 'pushRtmp') {
        const { classroomCode } = this.$route.query
        const params = {
          classroomCode,
          action: e.target.checked ? true : false
        }
        const result = await this.$http.clientSettingPushOrStopCdn(params)
        if (result.code !== 200) return this.$message.error('抱歉，设置失败！')
        const resultReal = result.rt || {}
        if (resultReal.resultStatus !== 1) return this.$message.error(resultReal.resultMessage || '抱歉，设置失败！')
        this.$emit('getClientSettings')
        return
      }
      try {
        const params = JSON.parse(JSON.stringify(this.clientSettingsInfo))
        Object.assign(params, {
          [item.key]: e.target.checked ? 1 : 0
        })
        this.clientSettingEdit(params)
      } catch (err) {
        console.log(err)
      }
    },
    initAliplayerVideo(url) {
      const props = {
        id: 'J_prismPlayer',
        width: '100%',
        height: '100%',
        autoplay: true,
        preload: true,
        controlBarVisibility: 'always',
        useH5Prism: true,
        playsinline: true,
        isLive: false,
        language: 'zh-cn',
        source: '',
        cover: '',
        components: [],
        skinLayout: []
      }
      this.$nextTick(() => {
        this.playerForAliplayer = new Aliplayer(props)
        url && this.playerForAliplayer.loadByUrl(url)
      })
    },
    disposeAudioSetting() {
      const _that = this
      if (this.rtcType === 'artc') {
      } else {
        if (this.testMicFlag) {
          // const domAudio = document.querySelector(`#${this.domAudioId}`)

          const audioStreamId = (this.dialogDetailInfo.currentAudioDevice[0] || { streamId: '' }).streamId
          const audioStream = this.streamMap.get(audioStreamId)
          if (audioStream) {
            // if (domAudio) {
            // domAudio.srcObject = audioStream
            // }

            const audioContext = (this.testAudioContext = new AudioContext())
            const mediaStreamSourceNode = audioContext.createMediaStreamSource(audioStream)
            const scriptProcessorNode = audioContext.createScriptProcessor(4096, 1, 1)
            mediaStreamSourceNode.connect(scriptProcessorNode)
            scriptProcessorNode.connect(audioContext.destination)
            scriptProcessorNode.onaudioprocess = function (buffer) {
              const nowBuffering = buffer.inputBuffer.getChannelData(0)
              const maxVal = Math.max.apply(Math, nowBuffering)
              _that.outpuLLevel = Math.round(maxVal * 100)
            }

            let lGainNode = audioContext.createGain()
            let rGainNode = audioContext.createGain()
            this.lGainNodeForOperationForStartTheMicrophone = lGainNode
            this.rGainNodeForOperationForStartTheMicrophone = rGainNode
            const splitter = audioContext.createChannelSplitter(2)
            const merger = audioContext.createChannelMerger(2)
            lGainNode.gain.value = 1
            rGainNode.gain.value = 1
            mediaStreamSourceNode.connect(splitter)
            splitter.connect(lGainNode, 0)
            splitter.connect(rGainNode, 1)
            lGainNode.connect(merger, 0, 0)
            rGainNode.connect(merger, 0, 1)
            merger.connect(audioContext.destination)
            this.lGainNodeForOperationForStartTheMicrophone.gain.value = this.volumeCount / 100
            this.rGainNodeForOperationForStartTheMicrophone.gain.value = this.volumeCount / 100
          }
        } else {
          this.testAudioContext && this.testAudioContext.close()
          _that.outpuLLevel = 0
          this.volumeCount = 40
          this.handleVolumeCountChange()
        }
      }
    },
    handleTestMic() {
      this.testMicFlag = !this.testMicFlag
      this.disposeAudioSetting()
    },
    handleVolumeCountChange() {
      if (!this.lGainNodeForOperationForStartTheMicrophone || !this.rGainNodeForOperationForStartTheMicrophone) return
      this.lGainNodeForOperationForStartTheMicrophone.gain.value = this.volumeCount / 100
      this.rGainNodeForOperationForStartTheMicrophone.gain.value = this.volumeCount / 100
    }
  }
}
</script>

<style lang="scss" scoped>
.inspection_tour_setting_container {
  .inspection_tour_setting_container_header {
    width: 100%;
    height: 60px;
    border-radius: 8px 8px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    border-bottom: 2px solid #eaeaea;
    .header_title {
      font-size: 16px;
      font-weight: 500;
      color: #1e2228;
    }
    .close_btn {
      width: 12px;
      height: 12px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  .inspection_tour_setting_container_body {
    width: 100%;
    height: 488px;
    display: flex;
    .inspection_tour_setting_menu {
      width: 192px;
      height: 488px;
      box-shadow: 1px 0px 1px 0px #eaeced;
      padding-top: 10px;
      li {
        width: 192px;
        height: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
        padding: 0 20px;
        &:hover {
          background: #e5e5f2;
        }
        img {
          width: 20px;
          height: 20px;
          display: block;
          margin-right: 12px;
        }
        p {
          color: #1e2228;
        }
        &.active {
          background: #5f60d3;
          p {
            color: #fff;
          }
        }
      }
    }
    .inspection_tour_setting_content {
      flex: 1;
      padding: 16px 20px 16px 16px;
      .video_setting {
        .video_setting_select {
          display: flex;
          align-items: center;
          h3 {
            font-size: 14px;
            font-weight: 600;
            color: #1e2228;
            margin-right: 16px;
          }
        }
        .video_setting_play {
          width: 432px;
          height: 243px;
          background-color: #000;
          margin-top: 16px;
          position: relative;
          video {
            width: 100%;
            height: 100%;
            object-fit: fill;
          }
          #J_prismPlayer {
            width: 100%;
            height: 100% !important;
          }
          .shooting_angle_btn {
            width: 96px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #3982ff;
            border-radius: 4px;
            font-size: 12px;
            color: #fff;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            cursor: pointer;
            user-select: none;
            &:hover {
              background: #3369c7;
            }
            &:active {
              background: #3982ff;
            }
            &.disabled {
              background: #72a0f0;
              cursor: not-allowed;
              display: none;
              &:hover {
                background: #72a0f0;
              }
              &:active {
                background: #72a0f0;
              }
            }
          }
          .video_setting_play_control_mask {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            padding-top: 12px;
            .device_title {
              font-size: 12px;
              color: #fff;
              text-align: center;
            }
            .direction_module {
              display: flex;
              justify-content: center;
              margin-top: 6px;
              .direction_module_circle {
                width: 136px;
                height: 136px;
                background-color: rgba(255, 255, 255, 0.2);
                box-shadow:
                  0px 0px 11px 2px rgba(53, 55, 68, 0.3),
                  inset 0px 1px 3px 0px rgba(216, 216, 216, 0.5);
                border-radius: 50%;
                position: relative;
                .direction_module_circle_button_of_one {
                  width: 48px;
                  height: 48px;
                  position: absolute;
                  border-radius: 50%;
                  overflow: hidden;
                  cursor: pointer;
                  user-select: none;
                  img {
                    width: 100%;
                    height: 100%;
                    display: block;
                  }
                }
              }
            }
            .zoom_module {
              display: flex;
              justify-content: center;
              position: relative;
              .zoom_module_title {
                position: absolute;
                color: #fff;
                left: 100px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 12px;
              }
              .zoom_module_button_of_one {
                width: 50px;
                height: 20px;
                background: #fff;
                border-radius: 2px;
                display: flex;
                justify-content: center;
                align-items: center;
                user-select: none;
                cursor: pointer;
                &:active {
                  background: #3982ff;
                }
                img {
                  width: 12px;
                  height: 12px;
                  display: block;
                }
              }
            }
            .footer_module {
              display: flex;
              justify-content: center;
              margin-top: 10px;
              .confirm_btn {
                width: 56px;
                height: 30px;
                background: #3982ff;
                border-radius: 4px;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                user-select: none;
                cursor: pointer;
                font-size: 12px;
                &:hover {
                  background: #3369c7;
                }
                &:active {
                  background: #3982ff;
                }
              }
            }
          }
        }
        .video_setting_footer {
          margin-top: 16px;
          ::v-deep.ant-checkbox-checked .ant-checkbox-inner {
            background-color: #5f60d3;
            border-color: #5f60d3;
          }
          ::v-deep.ant-checkbox-wrapper > span:nth-child(2) {
            font-size: 14px;
            color: #1e2228;
          }
          ::v-deep.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled > span:nth-child(2) {
            color: #a4abb6;
          }
          ::v-deep.ant-checkbox.ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner {
            background-color: #ebecf2;
            border-color: #ebecf2;
          }
        }
      }
      .audio_setting {
        .audio_setting_select {
          display: flex;
          align-items: center;
          h3 {
            font-size: 14px;
            font-weight: 600;
            color: #1e2228;
            margin-right: 16px;
            width: 70px;
            text-align: right;
          }
          .test_mic_btn {
            width: 94px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid #dcdee0;
            font-size: 14px;
            color: #1e2228;
            cursor: pointer;
            user-select: none;
            margin-left: 16px;
            &:hover {
              background: #f5f5f5;
            }
            &:active {
              background: #fff;
            }
          }
        }
        .audio_data_show {
          padding-left: 86px;
          margin-top: 12px;
          .audio_data_show_item {
            display: flex;
            align-items: center;
            .audio_data_show_item_title {
              display: flex;
              align-items: center;
              font-size: 14px;
              width: 56px;
              margin-right: 16px;
              justify-content: space-between;
              img {
                width: 20px;
                height: 20px;
                display: block;
                margin-left: 5px;
              }
            }
            ::v-deep.ant-slider {
              margin: 0;
            }
            ::v-deep.ant-progress-bg {
              background-color: #5f60d3;
              height: 4px !important;
            }
            ::v-deep.ant-slider-track {
              background-color: #5f60d3;
            }
            ::v-deep.ant-slider-handle {
              border-color: #5f60d3;
            }
            &:nth-of-type(2) {
              margin-top: 12px;
            }
          }
        }
        .advanced_setting {
          margin-top: 20px;
          .advanced_setting_title {
            display: flex;
            align-items: center;
            h3 {
              font-size: 14px;
              font-weight: 600;
              color: #1e2228;
              margin-right: 16px;
              width: 70px;
              text-align: right;
            }
            h4 {
              font-size: 14px;
              color: #6f7c91;
            }
          }
          .advanced_setting_body {
            padding-left: 86px;
            margin-top: 12px;
          }
        }
      }
      .general_setting {
        .general_setting_type_group {
          .general_setting_type_item {
            display: flex;
            margin-bottom: 32px;
            &:nth-last-child(1) {
              margin-bottom: 0;
            }
            h3 {
              width: 73px;
              font-weight: 500;
              text-align: right;
              padding-right: 16px;
              font-size: 14px;
            }
          }
        }
        .general_setting_btn_group {
          ::v-deep.ant-checkbox-checked .ant-checkbox-inner {
            background-color: #5f60d3;
            border-color: #5f60d3;
          }
          ::v-deep.ant-checkbox-wrapper > span:nth-child(2) {
            font-size: 14px;
            color: #1e2228;
          }
          ::v-deep.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled > span:nth-child(2) {
            color: #a4abb6;
          }
          ::v-deep.ant-checkbox.ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner {
            background-color: #ebecf2;
            border-color: #ebecf2;
          }
          .general_setting_btn_item {
            margin-bottom: 16px;
            &:nth-last-child(1) {
              margin-bottom: 0;
            }
          }
        }
        .version_container {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 65px;
          .logo {
            width: 60px;
            height: 60px;
            display: block;
          }
          .title {
            font-size: 14px;
            color: #1e2228;
            margin-top: 8px;
          }
          .sub_title {
            font-size: 14px;
            color: #6f7c91;
            margin-top: 8px;
          }
        }
      }
    }
  }
}
</style>
